import { render, staticRenderFns } from "./ScrollCard.vue?vue&type=template&id=46685cf3"
import script from "./ScrollCard.vue?vue&type=script&lang=js"
export * from "./ScrollCard.vue?vue&type=script&lang=js"
import style0 from "./ScrollCard.vue?vue&type=style&index=0&id=46685cf3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports